import axios from 'axios'
import { getAuthorizedConfiguration } from '../helpers/RequestHelper'

export const IS_LOADING_TAGS = 'IS_LOADING_TAGS'
export const SET_TAGS = 'SET_TAGS'
export const IS_CREATING_TAG = 'IS_CREATING_TAG'
export const ADD_TAG = 'ADD_TAG'

export const TAGS_ENDPOINT = '/content-assets/tags'

export const isLoadingTags = (status) => ({ type: IS_LOADING_TAGS, status })
export const setTags = (data) => ({ type: SET_TAGS, data })
export const isCreatingTag = (status) => ({ type: IS_CREATING_TAG, status })
export const addTag = (tag) => ({ type: ADD_TAG, tag })

export const loadTags = () => {
	return async function(dispatch, getState) {
		if (getState().contentAssetTags.get('loaded')) return
		dispatch(isLoadingTags(true))
		try {
			const oidcUser = getState().oidc.user
			const { serviceManagementBackendUrl } = window.config
			const config = getAuthorizedConfiguration(oidcUser)
			const url = `${serviceManagementBackendUrl}${TAGS_ENDPOINT}`
			const response = await axios.get(url, config)
			const payload = Array.isArray(response.data) ? response.data : []
			dispatch(setTags(payload))
		} catch (error) {
			dispatch(setTags([]))
		} finally {
			dispatch(isLoadingTags(false))
		}
	}
}

/**
 * Creates a tag if no row matches the canonical (trimmed lowercase) name.
 * Backend returns the existing tag with 200 if a match was found (Created=false on
 * the wire), or a freshly-inserted tag with 201. Either way the resulting tag is
 * appended to the in-memory list and returned to the caller.
 *
 * Throws on network/backend failure so the wizard's optimistic-add can roll back.
 */
export const createTag = (rawName) => {
	return async function(dispatch, getState) {
		dispatch(isCreatingTag(true))
		try {
			const oidcUser = getState().oidc.user
			const { serviceManagementBackendUrl } = window.config
			const config = getAuthorizedConfiguration(oidcUser)
			const url = `${serviceManagementBackendUrl}${TAGS_ENDPOINT}`
			const response = await axios.post(url, { name: rawName }, config)
			const tag = response.data
			// Append only if the tag isn't already in our cache (handles the dedup case).
			const existing = getState().contentAssetTags.get('tags').toJS()
			if (!existing.some((t) => t.Id === tag.Id)) {
				dispatch(addTag(tag))
			}
			return tag
		} finally {
			dispatch(isCreatingTag(false))
		}
	}
}
